// extracted by mini-css-extract-plugin
module.exports = {"content":"machines_content__4Dh11","center":"machines_center__2lbcp"};